import { SurveyUserRoles, UtrvUserRole } from '../constants/user';
import { SurveyScope } from './surveyCommon';
import { DataScopeAccess } from './surveyDataScope';

export interface Permission<Type extends string, Role extends string> {
  type: Type;
  modelId: string;
  roles: Role[];
}

export enum SurveyPermissionType {
  Workgroup = 'workgroup',
}

export interface SurveyPermission extends Permission<SurveyPermissionType, SurveyUserRoles> {
  /**
   * DataScopeAccess.Full: Have access to all scopes
   * DataScopeAccess.Partial: Have access to a subset of scopes that are listed in 'scope' field.
   * DataScopeAccess.None: No access to any scopes
   * Allow user to switch between full/none and partial access without reselect scopes.
   */
  access: DataScopeAccess;
  scope?: SurveyScope;
}

export enum UtrvPermissionType {
  Workgroup = 'workgroup',
}

export type UtrvPermission = Permission<UtrvPermissionType, UtrvUserRole>;
